import * as React from 'react';
import ReactDom from 'react-dom';
import { emporiModule } from '@empori/util';
import { Testimonials } from './components/testimonials';
import { NewsPagination } from './components/paginations';
import { CaseStudies, CaseStudiesList } from './components/caseStudies';
import { AlterNav } from './fns/alterNav';
import { LogotypeSlideshow } from './components/logotypesSlideshow';
import { DemoPopUp } from './fns/demoPopup';
import { translateForms } from './fns/translateForms';
import { PageHeaderMedia } from './components/pageHeaderMedia';
import { MediaAnimation } from './components/mediaAnimation';
emporiModule('netsetLoaded', {
    netset: {
        InitTestimonials: function (element, items) {
            ReactDom.render(React.createElement(Testimonials, { items: items }), element);
        },
        InitMainNav: function (element) {
            AlterNav(element);
        },
        InitLogotypeSlideshow: function (element, items) {
            ReactDom.render(React.createElement(LogotypeSlideshow, { items: items }), element);
        },
        InitDemoPopUp: function (element) {
            DemoPopUp(element);
        },
        InitCaseStudies: function (element, items) {
            ReactDom.render(React.createElement(CaseStudies, { items: items }), element);
        },
        InitPagination: function (element, items) {
            ReactDom.render(React.createElement(NewsPagination, { items: items }), element);
        },
        InitCaseStudiesList: function (element, items) {
            ReactDom.render(React.createElement(CaseStudiesList, { items: items }), element);
        },
        NetsetForms: function (culture) {
            translateForms(culture);
        },
        InitMedia: function (element, item) {
            ReactDom.render(React.createElement(PageHeaderMedia, { item: item }), element);
        },
        InitMediaAnimation: function (element, urls, style) {
            ReactDom.render(React.createElement(MediaAnimation, { urls: urls, style: style }), element);
        }
    }
});
